import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import BuildingListing from 'views/admin/building/BuildingListing'

import BuildingForm from 'views/admin/building/BuildingForm'

const Building = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <BuildingListing />
      </Route>
      <Route path={`${path}/new`}>
        <BuildingForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:buildingId`}>
        <BuildingForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default Building
